import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { style: {"color":"var(--xrk-color-primary)"} }, " 注：下载的列表数据除终端结算金额外其他内容请勿修改，否则会上传失败 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"20px","margin-top":"15px"} }, " 只能上传xls或xlsx文件,最大支持20M ", -1)

import { reactive, ref, computed } from 'vue';
import { BaseButton, BaseDialog, BaseUpload, XrkMessage } from 'xrk-components';
import { Download } from '@element-plus/icons-vue';
import { importSettlementAmountAjax } from '../data-source/apis';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'import-settlement-amount',
  props: {
    remove: { type: Function, default() {
      return () => ({});
    } }
  },
  emits: ['downLoadTaskList', 'refreshTabel'],
  setup(__props: any, { emit: __emit }) {

const store = useProjectDetailStore();

const props = __props;
const emits = __emit;

const projectInfo = computed(() => store.baseData.projectInfo);

const upload = ref(null);

const formData = reactive({
  fileList: []
});
const onCancel = () => {
  props.remove();
};

const onConfirm = async () => {
  if (formData.fileList.length <= 0) {
    XrkMessage.error('请先上传文件！');
    return;
  }
  await upload.value.submit();
  XrkMessage.success('导入成功');
  emits('refreshTabel');
  onCancel();
};
const httpRequest = ({ file }) => {
  return importSettlementAmountAjax({ file, projectId: projectInfo.value.id });
};
const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};
//列表下载
function downLoadTempLate() {
  emits('downLoadTaskList');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "436px",
    visible: true,
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    title: "导入金额"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        onClick: onCancel,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        click: onConfirm,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认导入")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(BaseUpload), {
          fileList: formData.fileList,
          "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((formData.fileList) = $event)),
          style: {"width":"400px"},
          ref_key: "upload",
          ref: upload,
          listType: "text",
          limit: 1,
          "limit-size": 20,
          accept: ['xls', 'xlsx'],
          httpRequest: httpRequest,
          "auto-upload": false,
          onError: onError,
          btnText: "请选择文件"
        }, {
          tip: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["fileList"])
      ]),
      _createVNode(_unref(BaseButton), {
        style: {"margin-left":"20px"},
        type: "text",
        icon: _unref(Download),
        onClick: downLoadTempLate
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 下载列表数据 ")
        ]),
        _: 1
      }, 8, ["icon"])
    ]),
    _: 1
  }))
}
}

})